import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { formatDecimal } from 'utils/formatter';
import styles from './Summary.css';

class Summary extends Component {
  render() {
    const {
      nonLoyaltyMemberTotal,
      loyaltyMemberTotal,
      remainingQuota,
      rewardsTotal,
    } = this.props;
    return (
      <div className={`col-md-12 ${styles.summary}`}>
        <div className="row">
          <div
            style={{ padding: '25px 0px 25px 0px' }}
            className="col-md-4 col-sm-4 text-center"
          >
            <div className={`col-md-12 col-sm-12 ${styles.total}`}>
              {formatDecimal(nonLoyaltyMemberTotal)}
            </div>
            <div className={`col-md-12 col-sm-12 ${styles.title}`}>
              NON-LOYALTY MEMBER
            </div>
          </div>
          <div
            style={{ padding: '25px 0px 25px 0px' }}
            className="col-md-4 col-sm-4 text-center"
          >
            <div className={`col-md-12 col-sm-12 ${styles.total}`}>
              {formatDecimal(loyaltyMemberTotal)}
            </div>
            <div className={`col-md-12 col-sm-12 ${styles.title}`}>
              LOYALTY MEMBER
            </div>
            {remainingQuota >= 0 && (
              <div
                className={`col-md-12 col-sm-12 ${styles['remaining-quota']}`}
              >
                {remainingQuota} members left
              </div>
            )}
          </div>
          <div
            style={{ padding: '25px 0px 25px 0px' }}
            className="col-md-4 col-sm-4 text-center"
          >
            <div className={`col-md-12 col-sm-12 ${styles.total}`}>
              {formatDecimal(rewardsTotal)}
            </div>
            <div className={`col-md-12 col-sm-12 ${styles.title}`}>
              REWARDS REDEEMED
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Summary.propTypes = {
  nonLoyaltyMemberTotal: PropTypes.number,
  loyaltyMemberTotal: PropTypes.number,
  rewardsTotal: PropTypes.number,
};

export default Summary;
